import React, { useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrash } from '@fortawesome/free-solid-svg-icons'
import { WheelManagementActionsConfirmModal } from './WheelManagementActionsConfirmModal'
import type { GrowthWheelVersionStatus } from '../../types/GrowthWheel'
import '../../css/gw-wheel-management.scss'

export function DeleteVersionAction({
  versionLabel,
  versionStatus,
  canDelete,
  hasEvaluations,
  isDeleting,
  onDelete,
}: {
  versionLabel: string
  versionStatus: GrowthWheelVersionStatus
  canDelete: boolean
  hasEvaluations: boolean
  isDeleting: boolean
  onDelete: () => void
}) {
  const [showConfirm, setShowConfirm] = useState(false)

  const isDraft = versionStatus === 'draft'
  const title = isDraft ? 'Delete draft?' : 'Delete version?'
  const message = isDraft
    ? 'Are you sure you want to delete this draft? All changes in this draft will be lost.'
    : `Are you sure you want to delete version "${versionLabel}"? This cannot be undone.`

  return (
    <>
      <div className="gw-version-bar__delete-wrap">
        <button
          type="button"
          onClick={() => canDelete && setShowConfirm(true)}
          disabled={!canDelete || isDeleting}
          className={`gw-version-bar__delete-btn ${
            canDelete ? '' : 'gw-version-bar__delete-btn--disabled'
          }`}
          title="Delete version"
          aria-label="Delete version"
        >
          <FontAwesomeIcon icon={faTrash} />
        </button>
        {!canDelete && hasEvaluations ? (
          <div className="gw-version-bar__tooltip">
            This version has assessments and cannot be deleted.
          </div>
        ) : null}
      </div>

      {showConfirm ? (
        <WheelManagementActionsConfirmModal
          tone="danger"
          confirmVariant="danger"
          title={title}
          confirmLabel="Delete"
          irreversibleMessage="This action cannot be undone."
          onCancel={() => setShowConfirm(false)}
          onConfirm={() => {
            onDelete()
            setShowConfirm(false)
          }}
        >
          <p className="gw-wm__hint">{message}</p>
        </WheelManagementActionsConfirmModal>
      ) : null}
    </>
  )
}
